function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#000",
  fillRule: "nonzero",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.2 18.19h-9.723V8.618A.552.552 0 0020.912 8h-2.005a.68.68 0 00-.72.618v9.572H8.62a.68.68 0 00-.621.713v2.005a.559.559 0 00.621.57h9.569v9.719c.02.403.32.737.72.799h2.005c.362 0 .565-.437.565-.799v-9.72h9.724c.361 0 .795-.207.795-.569v-2.005a.841.841 0 00-.799-.713z",
  fill: "#FFF"
}));

function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAdd;